import { Button, Flex, Heading } from '@rocket/ui';
import type { FallbackProps } from 'react-error-boundary';
import { HOME_ROUTE } from '../../routes.config';
import { PageContent } from '../PageContent/PageContent';

export const ErrorFallback = ({ resetErrorBoundary }: FallbackProps) => (
  <PageContent>
    <Flex.V alignItems="center" justifyContent="center" gap="4" p="8">
      <Heading as="h1" size="xl">
        Something went wrong
      </Heading>
      <Heading as="h2" size="lg">
        An unexpected error occurred.
      </Heading>
      <Flex.H gap="3">
        <Button variant="outline" onClick={resetErrorBoundary}>
          Try again
        </Button>
        {/* Hard reload to home = clean state even if the current route keeps throwing. */}
        <Button onClick={() => window.location.assign(HOME_ROUTE)}>Return to home page</Button>
      </Flex.H>
    </Flex.V>
  </PageContent>
);
